import { render, staticRenderFns } from "./cardTemplate.vue?vue&type=template&id=f514fe48&scoped=true&"
import script from "./cardTemplate.vue?vue&type=script&lang=js&"
export * from "./cardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplate.vue?vue&type=style&index=0&id=f514fe48&prod&lang=scss&scoped=true&"
import style1 from "./cardTemplate.vue?vue&type=style&index=1&id=f514fe48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f514fe48",
  null
  
)

export default component.exports